const appName = process.env.VUE_APP_NAME;
const appUrl = process.env.VUE_APP_URL;
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
const hasEms = process.env.VUE_APP_EMS_INTEGRATION;
const tempUrl = process.env.VUE_APP_TEMP_URL;

export { appName, appUrl, apiBaseUrl, hasEms, tempUrl };
